/**
 * Stable CSS class names for E2E — Customer Diagnostics.
 */
export const CDX = {
    page: 'customer-diagnostics-page',
    breadcrumbRow: 'customer-diagnostics-page__breadcrumb',
    filterCard: 'customer-diagnostics-page__filter-card',
    alertError: 'customer-diagnostics-page__alert-error',
    summaryCard: 'customer-diagnostics-page__summary-card',
    timelineCard: 'customer-diagnostics-page__timeline-card',
    timelineHeader: 'customer-diagnostics-page__timeline-header',
    datagrid: 'customer-diagnostics-page__datagrid',

    input: 'customer-diagnostics-input',
    inputSelect: 'customer-diagnostics-input--select',
    inputTextfield: 'customer-diagnostics-input--textfield',
    inputButton: 'customer-diagnostics-input--button',

    fieldParameterType: 'customer-diagnostics-field--parameter-type',
    fieldParameterValue: 'customer-diagnostics-field--parameter-value',
    btnFetch: 'customer-diagnostics-field--fetch',
    chipTimelineStatus: 'customer-diagnostics-field--timeline-status-chip',
} as const;

export const cdxCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
